import { create } from 'zustand'
import type { SceneActId } from '@/constants/acts'
import { resolveActForProgress } from '@/constants/acts'

interface SceneStore {
  activeActId: SceneActId
  rawProgress: number
  sceneReady: boolean
  setRawProgress(progress: number): void
  setSceneReady(ready: boolean): void
}

export const useSceneStore = create<SceneStore>((set) => ({
  activeActId: 'semente',
  rawProgress: 0,
  sceneReady: false,
  setRawProgress(progress) {
    set({
      rawProgress: progress,
      activeActId: resolveActForProgress(progress).id,
    })
  },
  setSceneReady(ready) {
    set({ sceneReady: ready })
  },
}))
